import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hotels24actions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchH24Organizations = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.H24_ORGANIZATIONS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.h24Organizations, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.h24_fetchOrganizationsSuccess(getParser(urls.h24Organizations)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}

/** @thunk **/
export const postH24Organization = organization => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organization)
    }
    const { auth } = getState()

    securedFetch(urls.h24Organizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.h24_saveOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация добавлена'))
        .catch(
            handleError(
                dispatch,
                actions.h24_saveOrganizationsFailure,
                'Что-то пошло не так!',
                'При сохранении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const updateH24Organization = (remoteId, payload) => (dispatch, getState) => {
    // prettier-ignore
    const { auth, h24Organizations: { entities: { organizations } } } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...organizations[remoteId], ...payload })
    }

    securedFetch(urls.h24Organizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.h24_updateOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация обновлена'))
        .catch(
            handleError(
                dispatch,
                actions.h24_updateOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteH24Organization = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.h24OrganizationSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.h24_deleteOrganizationSuccess(remoteId)))
        .then(() => toastr.success('Организация удалена'))
        .catch(
            handleError(
                dispatch,
                actions.h24_deleteOrganizationFailure,
                'Что-то пошло не так!',
                'При удалении организации произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/h24Api/h24Organizations.js